<template>
	<span
		class="inline-flex max-w-full rounded-md border border-amber-300 bg-amber-50 px-2 py-1 text-xs font-medium text-amber-900 whitespace-normal break-words"
		title="El mismo código está configurado para la empresa y Enlaceforte en este hotel. No se asignó un propietario."
	>
		Convenio por verificar
	</span>
</template>
